export default __webpack_public_path__ + "static/media/bg-cubes-mid.2d020761.png";